<ng-container [formGroup]="form" *ngIf="form != null">
  <div class="row">
    <div class="col-12">
      <h3>Setup GL Export Mapping</h3>
    </div>
  </div>
  <lib-checkbox
    [size]="CheckboxSizes.Small"
    formControlName="showNotExported"
    label="Show all possible mappings"></lib-checkbox>
  <div class="tableContainer">
    <table class="table table-sm">
      <thead>
        <tr>
          <th>NAME & LEVEL</th>
          <th>&nbsp;</th>
          <th>EXPORT</th>
          <th>CREDIT/DEBIT</th>
          <th [colSpan]="currentAccountCols">ACCOUNTS</th>
        </tr>
      </thead>
      <tbody formArrayName="sections">
        <ng-container *ngFor="let section of sections.controls; let sectionIndex = index">
          <ng-container
            [formGroupName]="sectionIndex"
            *ngIf="
              section.get('exportBy').value !== GlMappingTypes.NOT_EXPORTED ||
              form.get('showNotExported').value
            ">
            <tr class="subheader">
              <th>
                <div class="d-flex justify-content-between">
                  <small class="fw-bold mt-auto mb-auto">{{ section.get('name').value }}</small>
                </div>
              </th>
              <td>
                <select
                  class="d-inline-block form-control ms-2 mb-0 bg-white subheaderSelect"
                  formControlName="exportBy">
                  <option *ngFor="let opt of exportByTypes" [ngValue]="opt.val">
                    {{ opt.name }}
                  </option>
                </select>
              </td>
              <td class="placeholder-text" aria-hidden="true">&nbsp;</td>
              <td class="placeholder-text" aria-hidden="true">&nbsp;</td>
              <ng-container *ngIf="section.get('topCols').value.length == 0" formArrayName="cols">
                <td
                  *ngFor="let col of getArray(section, 'cols').controls; let colIndex = index"
                  [formGroupName]="colIndex">
                  {{ col.value.name }}
                  <select
                    *ngIf="
                      config.UseClasses && config.ExportFileType == GeneralLedgerExportTypes.QBO
                    "
                    formControlName="qboClass"
                    class="form-control mb-0 bg-white subheaderSelect">
                    <option [ngValue]="null" disabled></option>
                    <option *ngFor="let qboClass of qboClasses | async" [ngValue]="qboClass.Name">
                      {{ qboClass.Name }}
                    </option>
                  </select>
                </td>
              </ng-container>
              <ng-container *ngIf="section.get('topCols').value.length > 0">
                <td
                  *ngFor="let col of section.get('topCols').value"
                  [colSpan]="getColspan(col.key)">
                  {{ col.name }}
                </td>
              </ng-container>
            </tr>
            <ng-container *ngIf="section.get('topCols').value.length > 0" formArrayName="cols">
              <tr class="subheader">
                <th colspan="3">
                  <span class="w-100 placeholder-text" aria-hidden="true">&nbsp;</span>
                </th>
                <td
                  *ngFor="let col of getArray(section, 'cols').controls; let colIndex = index"
                  [formGroupName]="colIndex">
                  {{ col.value.name }}
                  <select
                    *ngIf="
                      config.UseClasses && config.ExportFileType == GeneralLedgerExportTypes.QBO
                    "
                    formControlName="qboClass"
                    class="form-control mb-0 bg-white subheaderSelect">
                    <option [ngValue]="null" disabled></option>
                    <option *ngFor="let qboClass of qboClasses | async" [ngValue]="qboClass.Name">
                      {{ qboClass.Name }}
                    </option>
                  </select>
                </td>
              </tr>
            </ng-container>
            <ng-container formArrayName="rows">
              <ng-container
                *ngFor="let row of getArray(section, 'rows').controls; let rowIndex = index"
                [formGroupName]="rowIndex">
                <tr *ngIf="!row.get('notExported').value || form.get('showNotExported').value">
                  <td>
                    {{ row.get('name').value }}
                  </td>

                  <td>&nbsp;</td>
                  <td>
                    <lib-checkbox
                      formControlName="notExported"
                      [size]="CheckboxSizes.Small"
                      [label]="'Not Exported'"></lib-checkbox>
                  </td>
                  <td>
                    <select
                      class="form-control mb-0 subheaderSelect me-5"
                      formControlName="transactionType">
                      <option [ngValue]="'Credit'">Credit</option>
                      <option [ngValue]="'Debit'">Debit</option>
                    </select>
                  </td>
                  <ng-container formArrayName="accounts">
                    <td
                      *ngFor="
                        let account of getArray(row, 'accounts').controls;
                        let accountIndex = index
                      "
                      [formGroupName]="accountIndex">
                      <input
                        *ngIf="config.ExportFileType != GeneralLedgerExportTypes.QBO"
                        class="form-control mb-0"
                        formControlName="value" />
                      <select
                        *ngIf="config.ExportFileType == GeneralLedgerExportTypes.QBO"
                        class="form-control mb-0"
                        formControlName="value">
                        <option [ngValue]="null" disabled></option>
                        <option
                          *ngFor="let qboAccount of qboAccounts | async"
                          [value]="qboAccount.FullyQualifiedName">
                          {{ qboAccount.FullyQualifiedName }}
                        </option>
                      </select>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="row" *ngIf="(balance | async) != null">
    <div class="col-12">
      <span class="fw-bold">Balance: </span>
      <span *ngIf="(balance | async) >= 0" class="text-cp-green">{{
        balance | async | currency: '' : ''
      }}</span>
      <span *ngIf="(balance | async) < 0" class="text-danger"
        >({{ balance | async | absoluteValue | currency: '' : '' }})</span
      >
    </div>
  </div>
  <div class="row mb-5">
    <div class="col-12 text-end">
      <button class="btn btn-secondary me-3" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" (click)="submit()">Save Setup</button>
    </div>
  </div>
</ng-container>
